import { useState } from 'react';
import { Account } from 'contexts/accounts/types';
import { DeepTeams, Team } from 'contexts/teams/types';
import { FEATURE_FLAGS, useBooleanFlag } from 'hooks/useFeatureFlags';
import InviteToTeam from '../InviteToTeam';
import TeamInviteWizard from '../TeamInviteWizard';

interface IInviteToTeamHook {
  inviteToTeamModal: JSX.Element;
  closeInviteToTeamModal(): void;
  openInviteToTeamModal: (params: OpenInviteToTeamModal) => void;
}

interface OpenInviteToTeamModal {
  onClose: (data: boolean) => void;
  team: Team | DeepTeams | null;
  account: Account;
  isInvite: boolean;
}

const useInviteToTeam = (): IInviteToTeamHook => {
  const [modal, setModal] = useState<JSX.Element>(null);
  // Every team-invite entry point goes through here, so the flag switches them all at once.
  const skillDiveFlow = useBooleanFlag(FEATURE_FLAGS.SKILL_DIVE_LICENSE_FLOW);

  const handleOpenModal = ({ onClose, team, account, isInvite }) => {
    setModal(
      skillDiveFlow ? (
        <TeamInviteWizard onClose={onClose} team={team} account={account} isInvite={isInvite} />
      ) : (
        <InviteToTeam
          onClose={onClose}
          team={team}
          account={account}
          isVisible={true}
          isInvite={isInvite}
        />
      )
    );
  };

  return {
    inviteToTeamModal: modal,
    closeInviteToTeamModal: () => setModal(null),
    openInviteToTeamModal: handleOpenModal,
  };
};

export default useInviteToTeam;
